import { InjectionToken } from '@angular/core';

export const POPOVER_DATA = new InjectionToken('popover.data');
